export default __webpack_public_path__ + "4e44ca5f816c5a848d20e2a78144c539.png";